module.exports = __webpack_public_path__ + "static/media/bell-red.cae60a58.svg";